export const climateBadgeIds = [
  "climatePositiveMonths3",
  "climatePositiveMonths6",
  "climatePositiveMonths12",
  "climatePositiveMonths24",
  "climatePositiveMonths36",
];
